module.exports = __webpack_public_path__ + "img/logo_anyfit_white.a4be1365.png";